export default __webpack_public_path__ + "static/media/icon-insights-performance-revenue.7f693afe.svg";